import { get, post, postPromiseAll } from "../request.js";
import { useUserInfoStore } from "@/store/modules/userInfo";
export const ApiGetAssignmentList = {
  get: () => {
    const userInfo = useUserInfoStore();
    return get(`/assignment/list?ins=${userInfo.ins}`);
  },
};
export const ApiGetCompletedAssignment = {
  get: () => {
    return get(`/assignment/list?complete=true`);
  },
};
export const ApiGetAssignmentDetail = {
  get: (tid) => {
    return get(`/assignment/detail/${tid}`);
  },
};

export const ApiGetAssignmentRes = {
  get: (amid) => {
    return get(`/assignment/resource/${amid}`);
  },
};

export const ApiUploadVoice = {
  post: (amid, sid) => {
    return post(`/assignment/voice/${amid}/${sid}`);
  },
};

export const ApiGetCompletedTaskDetail = {
  get: (amid, sid) => {
    return get(`/get_student_assignment/${amid}/${sid}`);
  },
};

export const ApiUploadAllVoice = {
  post: (voiceList) => {
    // let tempList = [];
    // voiceList.forEach((item) => {
    //   let tempItem = {
    //     url: `/assignment/voice/${item.amid}/${item.sid}`,
    //     obj: item,
    //   };
    //   tempList.push(tempItem);
    // });
    return postPromiseAll(voiceList);
  },
};
